import { downloadCollectExcel, getSettlement, postTaxPdf } from "crud/auth.crud";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useLocation } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"
import { useSelector } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from "moment";
import Util from "pages/Dashboard/Common/Util";
import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal";
import Pagination from "pages/Custom/Pagination";

const SettlementDetails = (props) => {
  const location = useLocation()
  const selector = useSelector(state => state)
  const [dataList, setDataList] = useState([])
  const [modalShow, setModalShow] = useState(false)
  const [user, setUser] = useState(selector.auth.user)
  const [detailData, setDetailData] = useState()
  const [page, setPage] = useState(1)
  const [onUpload, setOnUpload] = useState(false);
  const [pagesGroup, setPagesGroup] = useState(1);
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4]);
  const [contentCount, setContentCount] = useState();
  const [pdfUrl, setPdfUrl] = useState();
  const [detailType, setDetailType] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]?.type || "")

  const getDataList = async () => {
    setOnUpload(true)
    const params = {
      page: page,
      company: props.companyId,
    }

    let url = '/summary_waste_collect/data_list/?page=' + params.page + '&company=' + params.company;

    const response = await getSettlement(url);
    let dataCount = response.data.count % 15 === 0 ? response.data.count / 15 : Math.floor(response.data.count / 15) + 1
    if (!contentCount || contentCount !== dataCount) {
      setContentCount(dataCount)
      let newArr = []
      for (let i = pagesGroup - 1; i < pagesGroup + 4; i++) {
        if (i + 1 <= dataCount) {
          newArr.push(i + 1)
        }
      }
      setPageArr(newArr)
    }
    if (response.status === 200) {
      const content = response.data?.results || [];
      if (content.length > 0) {
        setDataList([...content])
      } else {
        setDataList(false)
      }
    }
    setOnUpload(false)
  }
  
  const downloadExcel = async () => {
    let start_date = moment(detailData?.summary_date).subtract(1, 'months').format('YYYY-MM-DD')
    let end_date = moment(detailData?.summary_date).format('YYYY-MM-DD')
    if(moment(detailData?.summary_date).format('DD') == '01'){
      start_date = moment(detailData?.summary_date).format('YYYY-MM-DD')
      end_date = moment(detailData?.summary_date).add(1, 'months').format('YYYY-MM-DD')
    }

    const params = {
      company : user.member_group?.[0]?.company_group?.id,
      company_name : user.member_group?.[0]?.company_group?.name,
      price : detailData?.total_price,
      ym : moment(detailData?.summary_date).format('YYYY-MM'),
      start_date : start_date,
      end_date : end_date
    }
    const rs = await downloadCollectExcel(params)
    if(rs.data?.result === 'success'){
      let url = `https://waveradmin.ropiklabs.com/media/excel/${params.company}/${params.ym}-관리대장.xlsx`
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const excelUrl = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = excelUrl;
          link.setAttribute('download', `${moment(detailData?.summary_date).format('YYYY-MM')}_관리대장.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error(error)
        })
    }
  };

  const modalClose = () => {
    setModalShow(false)
  }

  const clickList = async (item) => {
    setDetailData(item);
    setModalShow(true)
  }

  useEffect(() => {
    getDataList()
  }, [page])

  return (
    <Row>
      <Col xs="12">
        <div className="email-rightbar mb-3">
          <Card>
            <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
              <div className="table-responsive">
                <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                  <thead className="chart-thead">
                    <tr>
                      <th scope="col" >업체명</th>
                      <th scope="col" >거래일자</th>
                      <th scope="col" >배출량(L)</th>
                      <th scope="col" >고지금액(원)</th>
                      <th scope="col" >완납여부</th>
                    </tr>
                  </thead>
                  <tbody className="chart-tbody clickable">

                    {
                      dataList && dataList.map((item, index) => {
                        return (
                          <tr className="pointer" key={item.id + '_' + index} onClick={() => { clickList(item) }}>
                            <td>{item.collection_company.name}</td>
                            <td>{moment(item.summary_date).format('YYYY-MM-DD')}</td>
                            <td>{Util.setCommaPrice(item.qty_l)}</td>
                            <td>{Util.setCommaPrice(item.total_price)}</td>
                            <td>{item.state === 'Y' ? '완납' : item.state === 'N' ? '미납' : '부분납부'}</td>
                          </tr>
                        )
                      })
                    }
                    {!dataList &&
                      <tr >
                        <td scope="row" colSpan="6">데이터가 없습니다.</td>
                      </tr>
                    }

                  </tbody>
                </table>
              </div>
            </CardBody>

          </Card>
          <Pagination contentCount={contentCount} pageArr={pageArr} pageCallBack={(page)=>{setPage(page)}} />
        </div>
      </Col>
      {onUpload && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'5%'}></img>
      </div>}
      <Modal title={'정산 내역 상세'} show={modalShow} onHide={modalClose} size="md">
        <div>
          <div style={{ padding: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>업체명</p>
              <p style={{ fontSize: 16, color: '#333', fontWeight: 'bold' }}>{detailData?.collection_company.name}</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>배출량</p>
              <p style={{ fontSize: 16, color: '#333', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.qty_l)} L</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>금액</p>
              <p style={{ fontSize: 16, color: '#333', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.price)} 원</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>VAT</p>
              <p style={{ fontSize: 16, color: '#333', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.vat)} 원</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>고지 금액</p>
              <p style={{ fontSize: 16, color: '#333', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.total_price)} 원</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>납부 금액</p>
              <p style={{ fontSize: 16, color: '#333', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.payed_price)} 원</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>미납 금액</p>
              <p style={{ fontSize: 16, color: '#333', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.total_price - detailData?.payed_price)} 원</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>완납 여부</p>
              <p style={{ fontSize: 16, color: '#333', fontWeight: 'bold' }}>{detailData?.state === 'Y' ? '완납' : detailData?.state === 'N' ? '미납' : '부분납부'}</p>
            </div>
            <button style={{ margin: "12px auto", display: "block" }} className="btn btn-primary w-md waves-effect waves-light" type="submit" onClick={() => {
              downloadExcel(detailData.total_price)
            }}>엑셀 다운로드
            </button>
          </div>
        </div>
      </Modal>
    </Row>

    //     </Container>
    //   </div>
    // </React.Fragment>
  )
}

export default SettlementDetails
